// types
import { type ModuleType as ReportCommercial } from "./_definitions"
import { type State } from "../../types"

export const reportCommercialSelector = (state: State): ReportCommercial => state.reportCommercial
